class RestoreOrganizationWorkflow {
	constructor(
		public readonly organizationId: number,
		public readonly workflowKey: string,
	) {
		Object.freeze(this);
	}
}

export default RestoreOrganizationWorkflow;
